
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const TITLE = 'title'
export const LANG = 'lang'
export const RTCSW = 'rtc'
export const WATERMARKSTRING = 'watermarkstring'
export const WATERMARKTOGGLE = 'watermarktoggle'
export const TRTCSW="tour"
export const CONFERENCE="conference"



// WEBPACK FOOTER //
// ./src/store/types.js